import { render, staticRenderFns } from "./MsPopover.vue?vue&type=template&id=66311408"
import script from "./MsPopover.vue?vue&type=script&lang=js"
export * from "./MsPopover.vue?vue&type=script&lang=js"
import style0 from "./MsPopover.vue?vue&type=style&index=0&id=66311408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports